import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/ambassadors")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/ambassadors", replace: true });
    },
});
